import React from "react";
import { motion } from "framer-motion";

const NavLinks = [
  { tit: "Početna", changeView: "home" },
  { tit: "Moja Priča", url: "mojaprica" },
  { tit: "Kontakt", url: "kontakt" },
];

export default function Nav({ pageOn, setView }) {
  return (
    <motion.div
      variants={{
        hidden: { left: "-60vh" }, // Moves it left
        visible: { left: "calc(-50vh + 30px)" }, // Adjust as needed
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.7 }}
      className="z-[100] pl-[20px] flex items-center bg-[#0a0a0d] rotate-90 fixed top-[calc(50vh-30px)] w-[calc(100vh-2px)] h-[60px]"
    >
      <div className="w-[40px] h-[40px] bg-[#111] mb-[2px] mr-[20px]"></div>
      <ul className="flex gap-[10px]">
        {NavLinks.map((link, index) => (
          <motion.li
            variants={{
              hidden: { y: "100px" },
              visible: { y: "0" },
            }}
            transition={{
              duration: 0.4, // Duration for each item
              delay: index * 0.2 + 0.4, // Delay for each item to start after the previous one
            }}
            key={index}
            className=""
          >
            {link.changeView ? (
              <button
                onClick={() => setView(link.changeView)}
                className={`text-[15px] border-t-[1px] hover:border-[#7c0000] hover:bg-[#111] hover:opacity-100 tracking-[1.5px] px-[15px] uppercase font-light text-[white] h-[60px] flex items-center justify-center transition-all ease-in-out duration-300 ${
                  pageOn === link.changeView
                    ? "border-[#7c0000] bg-[#111] opacity-100"
                    : "opacity-70 border-[#000]"
                }`}
              >
                {link.tit}
              </button>
            ) : (
              <a
                href={link.url}
                className="text-[15px] border-t-[1px] hover:border-[#7c0000] border-[#000] hover:bg-[#111] hover:opacity-100 opacity-70 tracking-[1.5px] px-[15px] uppercase font-light text-[white] h-[60px] flex items-center justify-center transition-all ease-in-out duration-300"
              >
                {link.tit}
              </a>
            )}
          </motion.li>
        ))}
      </ul>
    </motion.div>
  );
}
